export default {
	colors: {
		black: '#121C1E',
		white: '#FFF',
		red: '#F03E1F',
		cream: '#FDF0D2',
		darkCream: '#EDDEBC',
		green: '#05A360',
		orange: '#F05137',
		dirtGreen: '#B0B3A0',
		grey: '#20282B',
	},

	mediaQuery: {
		DesktopSizeL: '2560px',
		DesktopSizeM: '1920px',
		DesktopSizeS: '1440px',
		DesktopSizeXS: '1280px',
		LaptopSize: '1024px',
		TabletSize: '768px',
		MobileSize: '601px',

		DesktopSizeLMin: '2559px',
		DesktopSizeMMin: '1919px',
		DesktopSizeSMin: '1439px',
		DesktopSizeXSMin: '1279px',
		LaptopSizeMin: '1023px',
		TabletSizeMin: '767px',
		MobileSizeMin: '600px',
	},
}
